import { useEffect, useState } from "react";
import moment from "moment";
import { useDispatch } from "react-redux";
import { changeContractStatusesClose } from "../../../../redux/actions/contractAction";

const useRecalculation = ({
    calc = { deals: [] },
    transactions = [],
    accessFeatures = {},
    valueAfterSubmit = {},
    cashMinusChange = 0,
    nonCash = 0,
    nonCashAccount = 0,
    bankTransaction = 0,
    handleCloseModal = () => {}
}) => {
    const dispatch = useDispatch();
    const [recalculationDeals, setRecalculationDeals] = useState([]);
    
    useEffect(() => {
        if (calc.deals && calc.deals.length) {
            const formattedCLosureDate = moment(valueAfterSubmit?.closureDate).format('YYYY-MM-DD')
            const recalculationDeals = calc.deals
            .filter((deal) => deal?.recalculation)
            .map(deal => ({...deal, closureDate: formattedCLosureDate}))

            setRecalculationDeals(recalculationDeals)
        }
    }, [calc.deals, valueAfterSubmit?.closureDate]);

    const isRecalculationOrderAfterClosing = accessFeatures['automatic.recalculation.order'];
    const isRecalculation = isRecalculationOrderAfterClosing && recalculationDeals.length > 0;

    const onRecalculationCloseContract = () => {
        valueAfterSubmit.closureDate = valueAfterSubmit?.closureDate
            ? moment(valueAfterSubmit.closureDate).format('YYYY-MM-DD')
            : moment().format('YYYY-MM-DD');

        const recalculationPayloadDeals = valueAfterSubmit.deals.map((deal) => {
            const transaction = transactions.find((transaction) => transaction.dealId === deal.dealId);
            if (transaction) {
                return {
                    ...deal,
                    recalculationInfo: {
                        accepted: transaction.accepted,
                        documentNumber: transaction.documentNumber,
                        passport: transaction.passport,
                        additionalInfo: transaction.attachment,
                        section: transaction.section.value,
                        attachment: transaction.description
                    },
                };
            } 
            return deal
        });

        const data = {
            ...valueAfterSubmit,
            deals: recalculationPayloadDeals,
            deposit: {
                cash: +cashMinusChange,
                nonCash: +nonCash,
                nonCashAccount: +nonCashAccount,
                bankTransaction: +bankTransaction,
            },
        };
        dispatch(changeContractStatusesClose(data, transactions));
        handleCloseModal(true)
    };

    const isRecalculationTransaction = (transaction) => {
        return transaction.section === 'CLOSURE_RECALCULATION' && transaction.accepted;
    };

    return { recalculationDeals, isRecalculation, isRecalculationOrderAfterClosing, onRecalculationCloseContract, isRecalculationTransaction };
};

export default useRecalculation;